import CheckIcon from '@mui/icons-material/Check'
import ClearIcon from '@mui/icons-material/Clear'
import Stack from '@mui/material/Stack'
import { useTranslation } from 'react-i18next'

import CustomIconButton from '@/components/inputs/CustomIconButton'

type CancelConfirmIconButtonsProps = {
  disabled?: boolean
  /**
   * Disabled state for cancel button.
   * If not provided, falls back to the `disabled` prop
   */
  cancelDisabled?: boolean
  onCancelClick?: () => void
  onConfimClick?: () => void
}

function CancelConfirmIconButtons({
  disabled,
  cancelDisabled,
  onCancelClick,
  onConfimClick,
}: Readonly<CancelConfirmIconButtonsProps>) {
  const { t } = useTranslation()

  return (
    <Stack direction="row" gap={0.5}>
      <CustomIconButton
        Icon={ClearIcon}
        disabled={cancelDisabled ?? disabled}
        iconProps={{
          titleAccess: t('common.button.cancel'),
        }}
        type="reset"
        onClick={onCancelClick}
      />

      <CustomIconButton
        Icon={CheckIcon}
        color="success"
        disabled={disabled}
        iconProps={{
          titleAccess: t('common.button.save'),
        }}
        type="submit"
        onClick={onConfimClick}
      />
    </Stack>
  )
}

export default CancelConfirmIconButtons
